import { Controller } from "@hotwired/stimulus"

// Generalised KML upload controller. Works with any form that has a GeoJSON textarea.
// Set data-kml-upload-textarea-id-value to the ID of the target textarea.
// Optionally set data-kml-upload-clear-field-id-value to clear a related field on success.
export default class extends Controller {
  static targets = ["fileInput", "submitButton", "status"]
  static values = { url: String, textareaId: String, clearFieldId: String }

  convert(event) {
    event.preventDefault()

    const file = this.fileInputTarget.files[0]
    if (!file) {
      this.showStatus("Please select a KML or KMZ file first.", "danger")
      return
    }

    const formData = new FormData()
    formData.append("kml_file", file)

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Converting...'

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const headers = {}
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    fetch(this.urlValue, {
      method: "POST",
      body: formData,
      headers: headers
    })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          const textarea = document.getElementById(this.textareaIdValue)
          if (textarea) textarea.value = data.geojson_text
          if (this.clearFieldIdValue) {
            const clearField = document.getElementById(this.clearFieldIdValue)
            if (clearField) clearField.value = ""
          }
          let message = "KML converted successfully. GeoJSON has been loaded into the text area."
          if (data.warnings && data.warnings.length > 0) {
            message += " Note: " + data.warnings.join(" ")
          }
          this.showStatus(message, "success")
        } else {
          this.showStatus(data.error || "Conversion failed.", "danger")
        }
      })
      .catch(() => {
        this.showStatus("Network error. Please try again.", "danger")
      })
      .finally(() => {
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.innerHTML = 'Upload &amp; Convert'
      })
  }

  showStatus(message, type) {
    this.statusTarget.innerHTML = `<div class="alert alert-${type} py-1 px-2 mb-0 small">${message}</div>`
  }
}
